const ChangeRequest = {

    // PAGE HEADER
    change_requests: "Change Requests",

    // FILTERS
    search: "Search",
    premise: "Premise",
    unit: "Unit",
    request_type: "Request Type",
    status: "Status",

    // TABLE HEADERS
    table_request_id: "REQUEST ID",
    table_user_name: "USER NAME",
    table_premise: "PREMISE",
    table_unit: "UNIT",
    table_request_type: "REQUEST TYPE",
    table_request_name: "REQUEST NAME",
    table_status: "STATUS",
    table_requested_date: "REQUESTED DATE",

    // ACTION BUTTONS
    approve: "Approve",
    reject: "Reject",

    // CONFIRMATIONS
    confirm_approve_title: "Approve Change Request?",
    confirm_approve_text: "This change request will be marked as approved.",
    confirm_reject_title: "Reject Change Request?",
    confirm_reject_text: "This change request will be marked as rejected.",

    approved_success: "Request Approved.",
    rejected_success: "Request Rejected.",

    warn_select_premise: "Please select a premise first.",

    // STATUS LABELS
    status_pending: "Pending",
    status_approved: "Approved",
    status_rejected: "Rejected",

      // DETAILS MODAL
    details_title: "Change Request Details",
    table_field: "Field",
    table_old_value: "Old Value",
    table_new_value: "New Value",
    no_changes: "No change details available.",
    changes_count: "{{count}} field(s) updated",
    field_user_id: "User ID",
    field_login_email: "Login Email",
    field_login_mobile: "Login Mobile",
    field_vehicle_id: "Vehicle ID",
    field_vehicle_name: "Vehicle Name",
    field_vehicle_type: "Vehicle Type",
    field_vehicle_number: "Vehicle Number",
    field_vehicle_sticker: "Vehicle Sticker",
    field_parking_id: "Parking ID",
    field_premise_id: "Premise ID",
    field_status: "Status",
    field_description: "Description",
    section_general: "General",
    section_user_info: "Profile Information",
    section_user_login: "Login Details",
    section_vehicle: "Vehicle Details",
}

export default ChangeRequest;